import type { Middleware } from '@reduxjs/toolkit';

// Redux state logger middleware that logs state changes to the backend
export const stateLoggerMiddleware: Middleware = (store) => (next) => (action) => {
  // Get state before action
  const prevState = store.getState();

  // Execute the action
  const result = next(action);

  // Get state after action
  const nextState = store.getState();

  // Log state change to backend (async, non-blocking)
  if (action.type !== '@@INIT' && !action.type.includes('persist/')) {
    const stateChange = {
      timestamp: new Date().toISOString(),
      action: {
        type: action.type,
        payload: action.payload,
      },
      prevState: {
        // Log only relevant parts to avoid huge payloads
        authUser: prevState.clerkAuth?.user?.email,
        requestsCount: prevState.requests?.ids?.length || 0,
        vendorsCount: prevState.vendors?.ids?.length || 0,
        notificationsCount: prevState.notifications?.ids?.length || 0,
      },
      nextState: {
        authUser: nextState.clerkAuth?.user?.email,
        requestsCount: nextState.requests?.ids?.length || 0,
        vendorsCount: nextState.vendors?.ids?.length || 0,
        notificationsCount: nextState.notifications?.ids?.length || 0,
      },
    };

    // Send to backend
    fetch('http://localhost:3001/api/logs/redux', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(stateChange),
    }).catch((error) => {
      // Silent fail - we don't want logging errors to break the app
      console.debug('Redux state logging failed:', error);
    });
  }

  return result;
};
